skrilla.controller('depositsCtrl', function ($scope, searchService, cacheService, srefService, constantsService) {
    $scope.key = "deposits";
    $scope.deposits = cacheService.getObjectOrElse("depositTable", [])
    $scope.providers = constantsService.getPaymentProviderLabels()

    function clickUsername(deposit){
        srefService.go("userDetails", {id: deposit.userId});
    }

    function clickRow(deposit){
        srefService.go("depositDetails", {id: deposit.id});
    }



    $scope.tableData = {
        columns: [
            {title: "Username", field: "username", onClick: clickUsername, isUsernameLink: true, tags: "userTags"},
            {title: "Provider", field: "provider", filter: {func: (it) => { return $scope.providers[it]}}},
            {title: "Amount", field: "amount", filter: {name: "dollarOrSkrilla", args: ['currency', true]}},
            {title: "Refund Status", field: "refundStatus"},
            {title: "Refunded Amount", field: "refundedAmount", filter: {name: "dollarOrSkrilla", args: ['currency', true]}},
            {title: "Effective Amount", field: "effectiveAmount", filter: {name: "dollarOrSkrilla", args: ['currency', true]}},
            {title: "Status", field: "status"},
            {title: "Currency", field: "currency"},
            {title: "Updated At", field: "updatedAt", filter:{name: 'dateTimeFormatter'}},
            {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}}
        ],
        rows: {orderBy: "-createdAt", onClick: clickRow},
        isSkrillaTable: true,
        data: $scope.deposits
    }

});
